import { withFormField } from '@gogame/form';

import Agreement from './Agreement';

export * from './Agreement';

const AgreementField = withFormField({ padding: 0 })(Agreement);

export default AgreementField;
